// Central SPINLAB contact info — single source of truth.
export const CONTACT = {
  phone: "(445) 234-1717",
  phoneRaw: "+14452341717",
  phoneHref: "tel:+14452341717",
  smsHref: "sms:+14452341717",
  email: "sergoryzhkov1@gmail.com",
  emailHref: "mailto:sergoryzhkov1@gmail.com",
  instagram: "@spinlab_auto_detailing",
  instagramHandle: "spinlab_auto_detailing",
  instagramUrl: "https://instagram.com/spinlab_auto_detailing",
  serviceArea: "Philadelphia & Surrounding Areas",
  city: "Philadelphia",
};
